'use strict';

angular.module('mobile-apps')
	.directive('liveEditEntry',[
		'$rootScope',
		'LanguageEntries',
		'EntryStatus',
		'EntryDetail',
		'EntryWarnings',
		'EventTracker',
		'focusElement',
        'Utilities',
		'$timeout',
		'$state',
		function(
			$rootScope,
			LanguageEntries,
			EntryStatus,
			EntryDetail,
			EntryWarnings,
			EventTracker,
			focusElement,
            Utilities,
			$timeout,
			$state
		) {
			return {
				scope:
				{
					entryData : '=', // Language-Entry instance
					activeEntry : '=', // Object with {key: <CURRENT-ENTRY-KEY>, entry: <CURRENT-FULL-ENTRY>}
					mobileApp : '=', // Mobile app instance
					group : '=', // Group instance
					sourceLanguage : '=', // Language instance
					language : '=', // Language instance
					tags : '=', // All the tags of the application
					entryIndex : '=', // Index of the Entry to know which one to activate next when navigation via tab
					hideId : '@', // If set to "true" it will not display the id column
					tagCategories: '=',
					entries: '=',
					roleInApp: '=',
					hasUserGroupPermissions: '='
				},
				templateUrl: 'modules/mobile-apps/views/live-edit-entry.client.directive.html',

				link: function (scope, elem, attrs) {

					scope.isMasterLang = scope.language.name === scope.mobileApp.baseLanguage;

					scope.languages = {
						base: scope.mobileApp.baseLanguage,
						entry: scope.language.name,
						source: scope.sourceLanguage.name
					};

					// Only in the master language do we hide the full id column
					// when hide-id is set
					scope.hideIdColumn = false;
					if (scope.language._id === scope.sourceLanguage._id && scope.hideId === 'true') {
						scope.hideIdColumn = true;
					}

					scope.showIdInsteadOfSourceText = false;
					if (scope.language._id === scope.sourceLanguage._id) {
						// If the source language and the display language are
						// the same we would display the same text twice. So
						// in this case we display the id of the entry left.
						scope.showIdInsteadOfSourceText = true;
					}

					scope.getMainBorderClasses = function (){
						if(scope.entryData.draft || scope.isThisEditActive()) {
							return 'draftColorBorder';
						}else if(!scope.entryData.value){
							return 'untranslatedColorBorder';
						}else if(scope.entryData.value){
							return 'translatedColorBorder';
						}
						return '';
					};

					scope.getMainLabelClasses = function()
					{
						if(scope.entryData.draft || scope.isThisEditActive()) {
							return 'draftColorText';
						}else if(!scope.entryData.value){
							return 'untranslatedColorText';

						}else if(scope.entryData.value){
							return 'translatedColorText';
						}
						return '';
					};

					scope.getMainLabelText = function(){
						if(scope.entryData.draft || scope.isThisEditActive()) {
							return 'Draft';
						}else if(!scope.entryData.value){
							return 'Empty';

						}else if(scope.entryData.value){
							return scope.isMasterLang?'Source':'Target';
						}
						return '';
					};

					scope.getCurrentDisplayField = function(){
						if(scope.entryData.draft || scope.isThisEditActive()) {
							return 'draft';
						}
						return 'target';
					};

					scope.isThisEditActive = function()
					{
						var active = (scope.activeEntry.key === scope.entryData.key);
						return active;
					};


					/**
					 * Returns if the given field has any issues
					 * @param field The name of the field: draft/target
					 * @returns {boolean}
					 */
					scope.hasIssues = function(field) {

						// Data for the check-functions
						var checkData = {
							base: {
								value: scope.entryData.baseValue,
								valueUpdatedAt: scope.entryData.baseValueUpdatedAt
							},
							entry: scope.entryData,
							isMasterLang: false,
							languages: scope.languages
						};
						if (checkData && checkData.languages && checkData.languages.base && checkData.languages.entry) {
							checkData.isMasterLang = checkData.languages.base === checkData.languages.entry;
						}

						// Get the existing issues
						var issues = EntryWarnings.getWarningMessages([field, 'source'], checkData);

						if (issues.length === 0) {
							return false;
						}
						return true;
					};


					scope.openEdit =  function()
					{
						if(!$rootScope.isDetailViewOpened){
							var entry = scope.entryData;
							var maxWords = 300;

							if(entry.locked) return;

							if(entry.value && entry.value.length > maxWords || entry.draft && entry.draft.length > maxWords){
								scope.openDetailView(true);
								return;
							}
							
							if(scope.activeEntry.key !== undefined || scope.activeEntry.entry) {
								scope.closeEdit(false, true);
							}
							if(entry.error){
								entry.error = undefined;
							}
							scope.activeEntry.key = entry.key;
							scope.activeEntry.entry = entry;

							scope.activeEntry.entry._initialDraft = scope.activeEntry.entry.draft;

							var newDraft = scope.activeEntry.entry.draft || scope.activeEntry.entry.value;
							if (scope.activeEntry.entry.draft !== newDraft) {
								scope.activeEntry.entry.draft = newDraft;
							}

							focusElement('editArea' + scope.entryIndex);
							$rootScope.isLiveEditActive = true;
						}
					};


					scope.textAreaKeypress = function(event)
					{
						if (event.keyCode === 27) {  // escape
							event.preventDefault();
							scope.closeEdit();
						}else if(event.keyCode === 9)  // tab
						{
							if(event.shiftKey){
								event.preventDefault();
								scope.closeAndPrevious.apply(this);
							}else{
								event.preventDefault();
								scope.closeAndNext.apply(this);
							}
						}else if( (event.which === 19) || ((event.which === 115 ||      //ctrl+s or cmd+s, ctrl+enter or cmd+enter
							event.which === 83 || event.which === 13) && (event.ctrlKey || event.metaKey)))
						{
							if(event.shiftKey){
								event.preventDefault();
								scope.closeAndNext.apply(this,[2]);
							}else{
								event.preventDefault();
								scope.closeAndNext.apply(this,[1]);
							}
						}
					};

					scope.liveEdit = function() {
						$rootScope.$broadcast('liveEditEntryDraft', { key: scope.entryData.key, draft: scope.entryData.draft });
					};

					scope.closeEdit = function(save, dontChangeState, callback)
					{
						$rootScope.isLiveEditActive = false;

						if (!save && scope.activeEntry && scope.activeEntry.entry) {
							// Reset to the initial draft in the case we do not
							// want to save the changes
							scope.activeEntry.entry.draft = scope.activeEntry.entry._initialDraft;
						}

						if (!dontChangeState) {
							$state.go('.', {
								entryId: ''
							}, {inherit: true, notify: false});
						}

						if(!save)
						{
							scope.activeEntry.key = undefined;
							scope.activeEntry.entry = undefined;
							if( typeof callback === 'function'){
								callback();
							}
							return;
						}
						var entry =
						{
							_id : scope.activeEntry.entry._id,
							key : scope.activeEntry.entry.key,
							draft : scope.activeEntry.entry.draft,
							value : scope.activeEntry.entry.value,
							valueUpdatedAt : scope.activeEntry.entry.valueUpdatedAt,
                            status: scope.activeEntry.entry.status
						};

						if(save === 2){
							entry.value = scope.activeEntry.entry.draft;
							scope.activeEntry.entry.draft = scope.activeEntry.entry._initialDraft;
							entry.draft = scope.activeEntry.entry._initialDraft;
						}
						scope.updateInPlace( entry, function(err, response)
						{
							if(err)
							{
								scope.entryData.error = err.message;
								return;
							}

							if(parseInt(entry.status)) {
							    response.status = entry.status;
                            }
							$rootScope.$broadcast('liveEditEntryValueChanged', { entry: response});

							scope.activeEntry.key = undefined;
							scope.activeEntry.entry = undefined;

							if( typeof callback === 'function'){
								callback();
							}
						});
					};

					scope.closeAndMove = function(save, nextIndex, direction, openEditModal)
					{
						scope.closeEdit(save, false,
							function(){
								$rootScope.$broadcast('liveEditEntrySelectIndex', {index: nextIndex, direction: direction, openEditModal: openEditModal});
							}
						);
					};

					scope.closeAndNext = function(save)
					{
						scope.closeAndMove.apply(this,[save, (scope.entryIndex + 1), 'positive']);
					};

					scope.closeAndPrevious = function(save)
					{
						scope.closeAndMove.apply(this,[save, (scope.entryIndex - 1), 'negative']);
					};

					//update entry draft value from inPlace Editing
					scope.updateInPlace = function(entry, callback)
					{
						var languageEntry = new LanguageEntries(
							{
								key: entry.key,
								draft: entry.draft,
								value: entry.value,
								valueUpdatedAt: entry.valueUpdatedAt,
                                status: entry.status,
							});

						languageEntry.$update({
							mobileAppId: scope.mobileApp._id,
							languageId: scope.language._id,
							entryId: entry._id
						}, function (response) {

							// Track the Translation update, for the values
							// value and draft save only if they got set or not
							var eventData = {
								key: languageEntry.key,
								value: !!languageEntry.value,
								draft: !!languageEntry.draft
							};
							EventTracker.track('Translation Update Success', 'Translation Update', eventData);

							if (angular.isFunction(callback)) {
								callback(null, response);
							}
						}, function (errorResponse) {
							var error = new Error(errorResponse.data.message);
							if (angular.isFunction(callback)) {
								callback(error);
							}
						});

					};


					/**
					 * Open entry detail view
					 */
					scope.openDetailView = function(openDirectly) {
						$rootScope.$broadcast('openDetailView', scope.mobileApp._id, scope.language._id, scope.group._id, scope.entryData._id, scope.entryIndex, openDirectly);
					};


					/**
					 * Gets called when somebody clicks on the status-icons
					 */
					scope.statusClick = function(entryStatus) {
					    if(parseInt(entryStatus) === 5) {
                            Utilities.showMessage('Translation Order Active', 'While part of a translation order, the translation status can’t be changed', 'warning');
                        } else {
                            EntryStatus.openModal(scope.mobileApp._id, scope.language._id, scope.group._id, [scope.entryData.key], scope.entries, scope.tags, scope.tagCategories);
                        }
					};


					scope.selectionChanged = function () {
						$rootScope.$broadcast('liveEditEntrySelectionChanged');
					};

					scope.$on('entryChanged', function (event, data) {
						if (data && data.entry && data.entry.key === scope.entryData.key) {
							var properties = [
								'draft',
								'value',
								'description',
								'locked',
								'maxLength',
								'valueUpdatedAt'
							];

							properties.forEach(function(property) {
								scope.entryData[property] = data.entry[property];
							});

							if (scope.isMasterLang) {
								scope.entryData.group = data.entry.group;
							}
						}
					});

					scope.$on('liveEditEntrySelectIndex', function (event, indexData) {
						var entryIndex = indexData.index;
						// Checks if the current field should get activated
						if (scope.entryIndex === entryIndex) {
							if(indexData.openEditModal) {
								return scope.openDetailView(true);
							}
							if(scope.entryData.locked) {
								var newIndex = entryIndex;
								if (indexData.direction === 'positive') {
									newIndex++;
								} else {
									newIndex--;
								}
								$rootScope.$broadcast('liveEditEntrySelectIndex', {index: newIndex, direction: indexData.direction, openEditModal: indexData.openEditModal});
							}
							// Make sure the current field should get activated, if key or id is specified
							if (indexData.key && scope.entryData.key !== indexData.key && scope.entryData.key !== indexData.link) {
								return;
							}
							if (indexData.id && scope.entryData._id !== indexData.id) {
								return;
							}
							// If edit isn't already active, open it
							if (scope.activeEntry.key !== scope.entryData.key) {
								scope.openEdit();
							}
						}
					});

				}
			};
		}
	]);
